
import Vue from 'vue';
import { ClientConstants } from '../client.constants';
import { PvdLink, PvdPopover } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import { Utils } from "../utils/Utils";

export default Vue.extend({
    name: 'BondInput',
    mounted() {
        let popoverTrigger = this.$refs['yield-popover-trigger'] as PvdLink;
        let popover = this.$refs['yield-popover'] as PvdPopover;
        popover.pvdTarget = popoverTrigger;
        popoverTrigger.addEventListener('click', function () {
            popover.pvdOpen = true;
        });
    },
    props: {
        bondOptions: Array,
        yieldValue: Number,
        selectedBond: String,
        bondValueInvalid: Boolean,
    },
    data: () => {
        return {
            yieldValueInvalid: false,
            clientConstants: ClientConstants,
            bondInformationContent: ClientConstants.BOND_INFORMATION_CONTENT,
            bondInlineError: ClientConstants.BOND_INLINE_ERROR,
            yieldPopoverContent: ClientConstants.YIELD_POPOVER_CONTENT,
            yieldNativeAttributes:
                '{"inputmode": "decimal", "pattern": "^(?=.)(?:(?:(?:0|[1-4]?[0-9])?(?:[.][0-9]{1,2})?)|50(?:[.]00?)?)$"}',
            bondNativeAttributes: '{"data-cy" : "bond-type-input"}',
            yieldInlineError: ClientConstants.YIELD_INLINE_ERROR,
        };
    },
    methods: {
        handleInput: function (e: any) {
            // check to ensure only one decimal
            Utils.handleInputDecimal(e);
            // check for a numeric key or a decimal or a cmd/ctrl key
            Utils.handleNumberInput(e);
        },
        onPaste: function (e: any) {
            // check if the copied paste is valid
            Utils.handlePasteValid(e);
        },
        yieldValueChanged: function (e: any) {
            this.yieldValueInvalid = false;
            let val =
                e.target.value.trim() === ''
                    ? 0
                    : parseFloat(parseFloat(e.target.value).toFixed(2));
            this.$emit('yieldValueChanged', val);
        },
        selectedBondChanged: function (e: any) {
            let val = e.target.value;
            this.$emit('selectedBondChanged', val);
        },
        handleYieldInvalid() {
            this.yieldValueInvalid = true;
        },
    },
});
